// @flow
import * as React from 'react';

import useCanShowProductSetting from './useCanShowProductSetting';
import { ProductIdsMap } from './utils';

const useVisibleProductSettingSections = () => {
    const canShow = useCanShowProductSetting();

    return React.useMemo(() => {
        return Object.keys(ProductIdsMap).filter(product => canShow(product));
    }, [canShow]);
};

export default useVisibleProductSettingSections;
